export const StringUtils = {
  isEmpty(s) {
    return s === null || s === undefined || /^\s*$/.test(s);
  },
};
